import { Badge, Box, Group, Stack, Text } from '@mantine/core';

import { CAMPAIGN_MESSAGE_TYPES } from '../../../../common/enums/enums';
import { getEnumColor } from '../../../../../utils/enumUtils';

const TypeCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;

    const badgeColor = getEnumColor(CAMPAIGN_MESSAGE_TYPES, rowData.type);
    return <Badge color={badgeColor}>{rowData.type}</Badge>;
};

const TypeColumn = () => ({
    accessorKey: 'type',
    header: 'Type',
    size: 2,
    minSize: 80,
    Cell: ({ cell }) => <TypeCell cell={cell} />,
});
export default TypeColumn;
